import { render, staticRenderFns } from "./ManagePopup.vue?vue&type=template&id=f5d1f9f8&"
import script from "./ManagePopup.vue?vue&type=script&lang=js&"
export * from "./ManagePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports